// @ts-check

import React from 'react';
import { bool, func } from 'prop-types';
import Typography from '@mui/material/Typography';
import KeyIcon from '@mui/icons-material/Key';
import Chip from '@mui/material/Chip';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import VisibilityIcon from '@mui/icons-material/Visibility';

/**
 * @component ProfileHeader
 * @param {Object} props
 * @param {boolean} props.canEdit
 * @param {()=>void} props.onOpenPwd
 * @param {()=>void} props.onCanEdit
 * @returns {JSX.Element}
 */
function ProfileHeader({ canEdit, onOpenPwd, onCanEdit }) {
	return (
		<section style={{ display: 'flex', justifyContent: 'space-between' }}>
			<Typography variant="h5">Profile</Typography>
			<div
				style={{ display: 'flex', gap: '0.5rem', transition: 'background-color 0.2s ease-in-out' }}
			>
				{!canEdit && (
					<Chip
						sx={{
							transition: 'all 0.2s ease-in-out',
							':hover': { backgroundColor: 'rgba(0, 0, 0, 0.12) !important' },
						}}
						component="div"
						icon={<KeyIcon />}
						label="CHANGE PASSWORD"
						variant="outlined"
						size="medium"
						onClick={onOpenPwd}
					/>
				)}
				<Chip
					sx={{
						transition: 'all 0.2s ease-in-out',
						':hover': { backgroundColor: 'rgba(0, 0, 0, 0.12) !important' },
					}}
					component="div"
					icon={
						canEdit ? <VisibilityIcon fontSize="small" /> : <BorderColorIcon fontSize="small" />
					}
					label={canEdit ? 'VIEW INFO' : 'EDIT INFO'}
					variant="outlined"
					size="medium"
					onClick={onCanEdit}
				/>
			</div>
		</section>
	);
}

ProfileHeader.propTypes = { canEdit: bool, onOpenPwd: func, onCanEdit: func };

export default ProfileHeader;
